/**
 * Brand config loader. Merges static config with API response.
 * Data-only — no DOM mutations.
 *
 * @param {{ apiClient?: { get(path: string, opts?: object): Promise<any> }, staticConfig?: import('../../contracts/brand.js').BrandConfig }} opts
 * @returns {{ load(signal?: AbortSignal): Promise<import('../../contracts/brand.js').BrandConfig> }}
 */
export function createBrandLoader({ apiClient, staticConfig } = {}) {
  return {
    async load(signal) {
      /** @type {import('../../contracts/brand.js').BrandConfig} */
      let config = { appTitle: 'Admin' };

      // Merge static config
      if (staticConfig) {
        config = { ...config, ...staticConfig };
      }

      // Merge API response
      if (apiClient) {
        try {
          const apiConfig = await apiClient.get('/settings/brand', { signal });
          if (apiConfig) {
            config = { ...config, ...apiConfig };
          }
        } catch {
          // Silent — use static defaults on failure.
        }
      }

      return config;
    },
  };
}
